import React from 'react';
import "../styles/App.scss";
import "../styles/PagesStyles.scss";
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
//components
import {originalProjectsList} from "../components/projectData/OriginalProjects";
import {fanartData} from "../components/projectData/FanArt";
import {dtiysData} from "../components/projectData/Dtiys";
import PolaroidPhoto from '../components/PolaroidPhoto';

function Homepage(){

    const allOgProjImages = originalProjectsList.reduce((acc,project)=>{
        if(project.previewimage){
            return[...acc,...project.previewimage];
        }
        return acc;
    },[]);

    const allFanartImgs = fanartData.reduce((acc,project)=>{
        // if(project.previewimage){
            return[...acc,...project.previewimage];
        // }
    },[]);

    const alldtiysImgs = dtiysData.reduce((acc,project)=>{
        //if(project.previewimage){
            return[...acc,...project.previewimage];
        //}
    },[]);
    
    return(
            
            <div className="Homepage-maincontent">
                <Typography variant="h1">Hello Visitor!</Typography>
                <Typography variant="h2">Welcome to my art portfolio site</Typography>
                <div className="PolaroidPhoto-Container">
                    {
                        allOgProjImages.map((previewimage,index)=>(
                            
                                <Box>
                                    <PolaroidPhoto
                                        vispart={previewimage.imagePath}
                                        photoName={previewimage.imageName}
                                        href={previewimage.projectPath}//have it link to page, but for now image
                                    />
                                </Box>
                            
                        ))
                    }
                    {
                        allFanartImgs.map((previewimage,index)=>(
                            <Box>
                                <PolaroidPhoto
                                    vispart={previewimage.imagePath}
                                    photoName={previewimage.imageName}
                                    href={previewimage.projectPath}
                                />
                            </Box>
                        ))
                    }
                    {
                        alldtiysImgs.map((previewimage,index)=>(
                            <Box>
                                <PolaroidPhoto
                                    vispart={previewimage.imagePath}
                                    photoName={previewimage.imageName}
                                    href={previewimage.projectPath}
                                />
                            </Box>
                        ))
                    }
                </div>
            </div>
        
    );
}

export default Homepage;